<div *ngIf="meeting$ | async as meeting; else loading" class="meeting-container">
  <lfx-meeting-header [meeting]="meeting"></lfx-meeting-header>
  <div *ngIf="meeting.youtube_upload_enabled" class="flex flex-row mb-2">
    <p-message severity="info" class="w-full" icon="fa-solid fa-info-circle text-20">
      <div class="w-full flex justify-between items-center">
        <p class="text-13">
          Please note this meeting is being recorded and uploaded to YouTube. By joining, you consent to be recorded and acknowledge that your presence may be
          publicly shared on YouTube, which operates under its own Terms of Service and Privacy Policy. For more information on how The Linux Foundation process
          personal data please see our <a href="https://www.linuxfoundation.org/privacy/" target="_blank" rel="noopener">Privacy Policy</a>. If you have
          specific concerns, please contact your project's Program Manager for actions.
        </p>
      </div>
    </p-message>
  </div>
  <lfx-meeting-form [meeting]="meeting" [password]="password"></lfx-meeting-form>
  <div class="flex flex-col items-center gap-3">
    <p class="text-xs font-opensans">Powered by</p>
    <img class="max-h-8 w-full" [src]="logoURL" />
  </div>
  <lfx-footer cookie-tracking="true"></lfx-footer>
</div>

<ng-template #loading>
  <div class="meeting-container">
    <!-- TODO: REPLACE -->
    <!-- <ngx-skeleton-loader count="1" [theme]="{ height: '225px' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="1" [theme]="{ height: '375px' }"></ngx-skeleton-loader> -->
  </div>
</ng-template>
